import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors } from '../../shared/theme/ticketColors';
import { useHasBusinessCapability } from '../../shell/session/hooks/useEffectiveBusinessCapabilities'
import { useGlobalFeatureFlags } from '../../shell/providers/GlobalFeatureFlagsProvider'
import { isGlobalFeatureOn } from '../../shell/feature-flags/globalFeatureFlagsService';
import { fetchLoyaltyBalance } from '../../loyalty/infra/loyaltyApi';
import { modalExperience } from '../../shared/modals/modalExperience.styles';

type Props = {
  customerId: string;
  mobile?: boolean;
};

/**
 * Saldo de puntos en ficha de cliente customer (online).
 * Solo visible con capability + flag loyalty.
 */
export function CustomerLoyaltyPointsPanel({ customerId, mobile = false }: Props) {
  const hasCap = useHasBusinessCapability('customer_loyalty');
  const { flags } = useGlobalFeatureFlags();
  const enabled = hasCap && isGlobalFeatureOn(flags, 'loyalty_integrations');
  const [balance, setBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !customerId) {
      setBalance(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void fetchLoyaltyBalance(customerId)
      .then((r) => {
        if (!cancelled) setBalance(r.ok ? r.balance : 0);
      })
      .catch(() => {
        if (!cancelled) setBalance(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [customerId, enabled]);

  if (!enabled) return null;

  const panelStyle = mobile ? styles.panelMobile : modalExperience.detailFlatSection;

  return (
    <View style={panelStyle} testID="customers.detail.loyalty">
      <Text style={mobile ? styles.titleMobile : modalExperience.detailBlockTitle}>Fidelización</Text>
      {loading ? (
        <Text style={styles.meta}>Consultando puntos…</Text>
      ) : balance == null ? (
        <Text style={styles.meta}>Sin datos de puntos (¿sin red?).</Text>
      ) : (
        <Text style={styles.balance} testID="customers.detail.loyalty.balance">
          {balance} pts
        </Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  panelMobile: {
    padding: spacing.md,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.border,
    gap: 4,
  },
  titleMobile: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  meta: { color: ticketColors.ink3, fontSize: 13 },
  balance: { color: ticketColors.ink, fontSize: 18, fontWeight: '700' },
});
